<template>
  <Modal title="移至退费" v-model="visible" width="680">
    <Form ref="refundForm" class="form" :model="formData" :rules="formRule" :label-width="110">
      <Row>
        <Col :span="22">
          <Form-item label="学员ID" prop="uid">
            <Row>
              <Col :span="14">
                <Input v-model="formData.uid" placeholder="学生ID" :disabled="uidDisabled"
                       @on-blur="onUidBlur"></Input>
              </Col>
              <Col :span="10">
                <Button type="primary" :loading="loadingRemain" @click="loadRemainHour"
                        style="margin-left: 10px;">查询课时
                </Button>
              </Col>
            </Row>
          </Form-item>
        </Col>
        <Col :span="22" v-if="remainLoaded">
          <Form-item label="学生信息">
            <span>{{ nickname }}{{ mobile ? ' / ' + mobile : '' }}</span>
          </Form-item>
        </Col>
        <Col :span="22" v-if="remainLoaded && tchChannel !== 2">
          <Form-item label="外教">
            <span>剩余 {{ foreignRemain }}</span>
            <span style="margin-left: 16px;">锁定 {{ foreignLock }}</span>
            <span style="margin-left: 16px;">本次扣减</span>
            <Input v-model.number="formData.foreignDeduct" placeholder="扣减"
                   style="width: 90px; margin-left: 8px;"></Input>
          </Form-item>
        </Col>
        <Col :span="22" v-if="remainLoaded && tchChannel !== 2">
          <Form-item label="中教">
            <span>剩余 {{ chineseRemain }}</span>
            <span style="margin-left: 16px;">锁定 {{ chineseLock }}</span>
            <span style="margin-left: 16px;">本次扣减</span>
            <Input v-model.number="formData.chineseDeduct" placeholder="扣减"
                   style="width: 90px; margin-left: 8px;"></Input>
          </Form-item>
        </Col>
        <Col :span="22" v-if="remainLoaded && tchChannel !== 2">
          <Form-item label="陪练">
            <span>剩余 {{ partnerRemain }}</span>
            <span style="margin-left: 16px;">锁定 {{ partnerLock }}</span>
            <span style="margin-left: 16px;">本次扣减</span>
            <Input v-model.number="formData.partnerDeduct" placeholder="扣减"
                   style="width: 90px; margin-left: 8px;"></Input>
          </Form-item>
        </Col>
        <Col :span="22" v-if="remainLoaded && tchChannel === 2">
          <Form-item label="可用">
            <span>剩余 {{ figAvailable }}</span>
            <span style="margin-left: 16px;">本次扣减</span>
            <Input v-model.number="formData.figAvailableDeduct" placeholder="扣减"
                   style="width: 90px; margin-left: 8px;"></Input>
          </Form-item>
        </Col>
        <Col :span="22" v-if="remainLoaded && tchChannel === 2">
          <Form-item label="锁定">
            <span>剩余 {{ figLock }}</span>
            <span style="margin-left: 16px;">本次扣减</span>
            <Input v-model.number="formData.figLockDeduct" placeholder="扣减"
                   style="width: 90px; margin-left: 8px;"></Input>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="退费原因" prop="remark">
            <Input type="textarea" :autosize="{minRows: 2, maxRows: 4}" :maxlength="200"
                   placeholder="请输入退费原因" v-model="formData.remark"></Input>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="外教引起">
            <Checkbox v-model="teacherCauseChecked" @on-change="onTeacherCauseChange">外教引起</Checkbox>
          </Form-item>
        </Col>
        <Col :span="22" v-if="teacherCauseChecked">
          <Form-item label="老师" prop="tchId">
            <TeacherSelect :category="[1, 2]" v-model="formData.tchId"
                           @change-select="onTchSelect"></TeacherSelect>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="短信验证码" prop="smsCode">
            <Row>
              <Col :span="12">
                <Input v-model="formData.smsCode" placeholder="短信验证码"></Input>
              </Col>
              <Col :span="12">
                <Button type="primary" :disabled="smsCodeDisabled" @click="sendSmsCode"
                        style="margin-left: 10px;">
                  {{ smsCodeDisabled ? smsCodeTime + '秒后重发' : '发送验证码' }}
                </Button>
              </Col>
            </Row>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible = false">取消</Button>
      <Button type="primary" size="large" :loading="loadingSubmit" @click="submit">确认</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'ToRefundModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: [Number, String],
      default: ''
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    return {
      visible: this.value,
      loadingRemain: false,
      loadingSubmit: false,
      remainLoaded: false,
      loadedUid: '',
      tchChannel: 1,
      nickname: '',
      mobile: '',
      stdStatus: '',
      foreignRemain: 0,
      foreignLock: 0,
      chineseRemain: 0,
      chineseLock: 0,
      partnerRemain: 0,
      partnerLock: 0,
      figAvailable: 0,
      figLock: 0,
      teacherCauseChecked: false,
      timer: null,
      smsCodeTime: 60,
      smsCodeDisabled: false,
      formData: {
        uid: '',
        remark: '',
        smsCode: '',
        tchId: null,
        tchName: '',
        foreignDeduct: 0,
        chineseDeduct: 0,
        partnerDeduct: 0,
        figAvailableDeduct: 0,
        figLockDeduct: 0
      },
      formRule: {
        uid: [
          { required: true, message: '请输入学员ID', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入退费原因', trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    uidDisabled () {
      return this.uid !== '' && this.uid !== null && this.uid !== undefined
    }
  },
  methods: {
    toNum (val) {
      if (val === '' || val === null || val === undefined) {
        return 0
      }
      let num = Number(val)
      if (isNaN(num)) {
        return 0
      }
      return num
    },
    resetForm () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.loadingRemain = false
      this.loadingSubmit = false
      this.remainLoaded = false
      this.loadedUid = ''
      this.tchChannel = 1
      this.nickname = ''
      this.mobile = ''
      this.stdStatus = ''
      this.foreignRemain = 0
      this.foreignLock = 0
      this.chineseRemain = 0
      this.chineseLock = 0
      this.partnerRemain = 0
      this.partnerLock = 0
      this.figAvailable = 0
      this.figLock = 0
      this.teacherCauseChecked = false
      this.smsCodeTime = 60
      this.smsCodeDisabled = false
      this.formData = {
        uid: this.uid || '',
        remark: '',
        smsCode: '',
        tchId: null,
        tchName: '',
        foreignDeduct: 0,
        chineseDeduct: 0,
        partnerDeduct: 0,
        figAvailableDeduct: 0,
        figLockDeduct: 0
      }
    },
    onUidBlur () {
      if (!this.formData.uid) {
        return
      }
      if (this.remainLoaded && String(this.loadedUid) === String(this.formData.uid)) {
        return
      }
      this.loadRemainHour()
    },
    loadRemainHour () {
      let self = this
      if (!self.formData.uid) {
        self.$Message.warning('请先输入学员ID')
        return
      }
      self.loadingRemain = true
      self.remainLoaded = false
      self.$http.get('/user/refund/remain-hour', { params: { uid: self.formData.uid } }).then(function (res) {
        self.loadingRemain = false
        if (res && res.status === 'ok' && res.data) {
          self.applyRemain(res.data)
        }
      }).catch(function () {
        self.loadingRemain = false
      })
    },
    applyRemain (data) {
      this.remainLoaded = true
      this.loadedUid = data.uid
      this.formData.uid = data.uid
      this.tchChannel = data.tchChannel
      this.nickname = data.nickname || ''
      this.mobile = data.mobile || ''
      this.stdStatus = data.stdStatus
      this.foreignRemain = this.toNum(data.foreignRemain)
      this.foreignLock = this.toNum(data.foreignLock)
      this.chineseRemain = this.toNum(data.chineseRemain)
      this.chineseLock = this.toNum(data.chineseLock)
      this.partnerRemain = this.toNum(data.partnerRemain)
      this.partnerLock = this.toNum(data.partnerLock)
      this.figAvailable = this.toNum(data.figAvailable)
      this.figLock = this.toNum(data.figLock)
      this.formData.foreignDeduct = this.toNum(data.foreignDeduct)
      this.formData.chineseDeduct = this.toNum(data.chineseDeduct)
      this.formData.partnerDeduct = this.toNum(data.partnerDeduct)
      this.formData.figAvailableDeduct = this.toNum(data.figAvailableDeduct)
      this.formData.figLockDeduct = this.toNum(data.figLockDeduct)
    },
    onTeacherCauseChange (val) {
      if (!val) {
        this.formData.tchId = null
        this.formData.tchName = ''
      }
    },
    onTchSelect (tch) {
      if (tch) {
        this.formData.tchId = tch.id
        this.formData.tchName = tch.firstName + ' ' + tch.lastName
      } else {
        this.formData.tchId = null
        this.formData.tchName = ''
      }
    },
    validateDeduct () {
      if (this.tchChannel === 2) {
        let availableDeduct = this.toNum(this.formData.figAvailableDeduct)
        let lockDeduct = this.toNum(this.formData.figLockDeduct)
        if (availableDeduct < 0 || availableDeduct > this.figAvailable) {
          this.$Message.warning('可用本次扣减不能大于该类剩余且不能为负')
          return false
        }
        if (lockDeduct < 0 || lockDeduct > this.figLock) {
          this.$Message.warning('锁定本次扣减不能大于该类剩余且不能为负')
          return false
        }
        return true
      }
      let foreignDeduct = this.toNum(this.formData.foreignDeduct)
      let chineseDeduct = this.toNum(this.formData.chineseDeduct)
      let partnerDeduct = this.toNum(this.formData.partnerDeduct)
      if (foreignDeduct < 0 || foreignDeduct > this.foreignRemain) {
        this.$Message.warning('外教本次扣减不能大于该类剩余且不能为负')
        return false
      }
      if (chineseDeduct < 0 || chineseDeduct > this.chineseRemain) {
        this.$Message.warning('中教本次扣减不能大于该类剩余且不能为负')
        return false
      }
      if (partnerDeduct < 0 || partnerDeduct > this.partnerRemain) {
        this.$Message.warning('陪练本次扣减不能大于该类剩余且不能为负')
        return false
      }
      return true
    },
    buildPayload () {
      let isFig = this.tchChannel === 2
      return {
        uid: this.formData.uid,
        remark: this.formData.remark,
        smsCode: this.formData.smsCode,
        teacherCause: this.teacherCauseChecked ? 1 : 0,
        tchId: this.teacherCauseChecked ? this.formData.tchId : '',
        tchName: this.teacherCauseChecked ? this.formData.tchName : '',
        foreignDeduct: isFig ? 0 : this.toNum(this.formData.foreignDeduct),
        chineseDeduct: isFig ? 0 : this.toNum(this.formData.chineseDeduct),
        partnerDeduct: isFig ? 0 : this.toNum(this.formData.partnerDeduct),
        figAvailableDeduct: isFig ? this.toNum(this.formData.figAvailableDeduct) : 0,
        figLockDeduct: isFig ? this.toNum(this.formData.figLockDeduct) : 0
      }
    },
    submit () {
      let self = this
      self.$refs.refundForm.validate(function (valid) {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          return
        }
        if (!self.remainLoaded) {
          self.$Message.warning('请先查询课时')
          return
        }
        if (self.teacherCauseChecked && !self.formData.tchId) {
          self.$Message.warning('请选择外教老师')
          return
        }
        if (!self.validateDeduct()) {
          return
        }
        self.loadingSubmit = true
        self.$http.post('/user/request-refund', self.buildPayload()).then(function (res) {
          self.loadingSubmit = false
          if (res && res.status === 'ok') {
            self.visible = false
            self.$Message.success('已移至退费库')
            if (self.successCallback) {
              self.successCallback()
            }
          }
        }).catch(function () {
          self.loadingSubmit = false
        })
      })
    },
    sendSmsCode () {
      let self = this
      if (!self.formData.uid) {
        self.$Message.warning('请先输入学员ID')
        return
      }
      self.$http.get('/userinfo/sendUpdateMobileSmsCode', {
        params: {
          uid: self.formData.uid,
          key: 'request_refund_sms'
        }
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.smsCodeDisabled = true
          self.$Message.success('验证码发送成功!')
          self.timer = setInterval(function () {
            if (self.smsCodeTime <= 0) {
              self.smsCodeDisabled = false
              self.smsCodeTime = 60
              clearInterval(self.timer)
              self.timer = null
            } else {
              self.smsCodeTime -= 1
            }
          }, 1000)
        } else {
          self.$Message.error('验证码发送失败!')
        }
      }).catch(function () {
        self.$Message.error('验证码发送失败!')
      })
    }
  },
  watch: {
    value (val) {
      this.visible = val
      if (val) {
        this.resetForm()
        if (this.formData.uid) {
          this.loadRemainHour()
        }
      }
    },
    visible (val) {
      this.$emit('input', val)
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// ToRefundModal.vue?544095ea